import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader } from "@/components/common";
import { api, fmtDateTime } from "@/lib/api";

export default function AuditLogs() {
  const [action, setAction] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/audit-logs", { params: { action, page } }).then((r) => setData(r.data)), 250);
    return () => clearTimeout(t);
  }, [action, page]);

  return (
    <div>
      <PageHeader eyebrow="Compliance" title="Audit logs" subtitle="Every sensitive action — contact views, unlocks, credit changes, approvals — is recorded." />
      <div className="relative mb-4 max-w-md"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9 font-mono text-sm" placeholder="Filter by action prefix, e.g. credits." value={action} onChange={(e) => { setAction(e.target.value); setPage(1); }} data-testid="audit-filter-input" /></div>
      <div className="bg-card rounded-xl border overflow-x-auto fade-up">
        <Table data-testid="audit-logs-table">
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Target</TableHead><TableHead>Details</TableHead><TableHead>IP</TableHead></TableRow></TableHeader>
          <TableBody>
            {(data?.items || []).map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs whitespace-nowrap">{fmtDateTime(l.created_at)}</TableCell>
                <TableCell className="text-sm">{l.actor_email || "—"}<p className="text-xs text-muted-foreground">{l.actor_role}</p></TableCell>
                <TableCell className="font-mono text-xs">{l.action}</TableCell>
                <TableCell className="font-mono text-[11px] text-muted-foreground">{l.target_type}{l.target_id ? ` · ${l.target_id.slice(0, 8)}` : ""}</TableCell>
                <TableCell className="font-mono text-[11px] max-w-xs truncate">{Object.keys(l.details || {}).length ? JSON.stringify(l.details) : "—"}</TableCell>
                <TableCell className="font-mono text-[11px]">{l.ip}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {data?.pages > 1 && (
        <div className="flex items-center justify-end gap-3 mt-4">
          <Button variant="outline" size="icon" disabled={page <= 1} onClick={() => setPage(page - 1)}><ChevronLeft className="h-4 w-4" /></Button>
          <span className="text-sm font-mono">{page} / {data.pages}</span>
          <Button variant="outline" size="icon" disabled={page >= data.pages} onClick={() => setPage(page + 1)}><ChevronRight className="h-4 w-4" /></Button>
        </div>
      )}
    </div>
  );
}
